// extracted by mini-css-extract-plugin
export default {"container":"Section_container__ftwid","header":"Section_header__SZu-r","title":"Section_title__u388p","link":"Section_link__uFfvq","menu":"Section_menu__2UqVc"};